import React from 'react'
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import "./YourPosts.scss"

function YourPosts({ id, Title, Content, PhotoUrl, name, index, Time, onClick }) {
    const sanitizeText = (html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        return doc.body.textContent || '';
      };

      // Define the box-shadow style based on the index
  const getBoxShadowStyle = (index) => {
    const postsPerSet = 3; // Number of posts in each set

    const postIndexInSet = index % postsPerSet; // Calculate the index of the current post within the set

    switch (postIndexInSet) {
      case 0:
        return '5px 5px 0px #121212'; // Posts on the left
      case 1:
        return '0 5px 0px #121212'; // Posts in the middle
      case 2:
        return '-5px 5px 0px #121212'; // Posts in the right
     
      default:
        return '5px 5px 0px #121212'; // Default style (no shadow)
    }
  };
  console.log("postsid:" + id);

  const boxShadowStyle = getBoxShadowStyle(index);

  // Function to format the time from the Time
  const formatTime = (Time) => {
    const dateObj = Time.toDate();
    let hours = dateObj.getHours();
    const minutes = dateObj.getMinutes().toString().padStart(2, '0');

    // Convert 24-hour format to 12-hour format and add AM or PM
    const amPm = hours >= 12 ? 'PM' : 'AM';
    hours = (hours % 12) || 12; // Convert 0 to 12 for midnight (0) and noon (12)

    return `${hours}:${minutes} ${amPm}`;
  };

  // Function to format the date from the Time
  const formatDate = (Time) => {
    const dateObj = Time.toDate();
    const month = dateObj.toLocaleString('default', { month: 'long' });
    const day = dateObj.getDate();
    const year = dateObj.getFullYear();
    return `${month} ${day}, ${year}`;
  };
  return (
    <div>
      
      <Row className="g-4">

        <Col className='p-2 rowIt'>
          {PhotoUrl ? (
            <Card className='BlogCard' key={id} style={{ boxShadow: boxShadowStyle }} onClick={onClick} >

              <div className="imageHold3">
                <Card.Img variant="top" src={PhotoUrl} className='hoverable' />
              </div>

              <Card.Body>

                <Card.Text disabled className='blocker' data-name={name} >
                  <div className="TextCont1">
                    <p className='text-left small-text TextContSmall' ><strong>@</strong>{name} - {formatDate(Time)}</p>
                  </div>
                </Card.Text>
                <div className="TextCont">
                  <Card.Title className='text-left BoldText'>{Title}</Card.Title>
                  <Card.Text>

                    <p className='text-left Content'
                      dangerouslySetInnerHTML={{ __html: sanitizeText(Content) }}></p>

                  </Card.Text>


                </div>

              </Card.Body>
              <div className="timer">
                <Card.Text >
                  <p >{formatTime(Time)}</p>
                </Card.Text>
              </div>
            </Card>
          ) :
            (
              <Card className='BlogCard' key={id} style={{ boxShadow: boxShadowStyle }} onClick={onClick} >


                <Card.Body>

                  <Card.Text disabled className='blocker' data-name={name} >
                    <div className="TextCont1">
                      <p className='text-left small-text TextContSmall' ><strong>@</strong>{name} - {formatDate(Time)}</p>
                    </div>
                  </Card.Text>
                  <div className="TextCont2">
                    <Card.Title className='text-left BoldText'>{Title}</Card.Title>
                    <Card.Text>

                      <p className='text-left Content'
                        dangerouslySetInnerHTML={{ __html: sanitizeText(Content) }}></p>

                    </Card.Text>


                  </div>

                </Card.Body>
                <div className="timer">
                  <Card.Text >
                    <p >{formatTime(Time)}</p>
                  </Card.Text>
                </div>
              </Card>
            )}
        </Col>

      </Row>
    </div>
  )
}

export default YourPosts
